import React, { useEffect, useState } from "react"
import { jsPDF } from "jspdf"
import logo from "../image/logo_alo.png"
import autoTable from "jspdf-autotable"
import type { PressData } from "../models/listpress"
import type { TabStypeItem } from "../models/typeAnnonce"
import useAppContext from "../hooks/useAppContext"
import type { AppContextType } from "../context/AppContext"
import { format } from "date-fns"
import { getUserDetails,updateUserPoints } from "../services/User_service"
import { createFreeAnnouncement, getAllAnnonceByUser, createAnnonceForBilling } from "../services/Annonce_service"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import PromoCodeModal from "../page/admin/codePromo/PromoCodeModal"
import type { Annonce } from "../models/AnnonceModel"
import { useUserLoyaltyCommission } from "../hooks/useLoyaltyCommission"
import { applyPointsForDiscount, createTransaction } from "../services/Payment_service"
import { getUtilisableAvoirs } from "../services/Avoir_service"
import { CreditNoteType } from "../static/types/creditNoteType"
import type { UserModel } from "../models/UserModel"
import promoCodeService from "../services/promoCodeService"
import BillingClientModal from "../page/client/clientManagement/BillingClientModal"
import BillingEmailModal from "../page/client/clientManagement/BillingEmailModal"
import { sendMail } from "../services/Mail_service"
import { createCheckoutSession } from "../services/stripeService"
import "../css/Validation.css"
import EmailModal from "../page/admin/EmailModal"
import { usePointsCalculator } from "../hooks/usePointsCalculator"
import ValidationHeader from "./ValidationHeader"
import ValidationFooter from "./ValidationFooter"
import SoldeRemiseModal from "./SoldeRemiseModal"


interface ValidationProps {
  selectedSupport: PressData | null
  txtAnnonce: string
  entete: string
  floid: string
  annonceur: string
  denomination: string
  reference: string
  dateParution: Date
  nJustif: number
  tv_intra: number
  type_annonce: TabStypeItem | null
  activeIndex: number
  paymentRef: string | null
  setActiveIndex: (activeIndex: number) => void
  updateTxtAnnonce: (newTxt: string) => void
  updateFloid: (newTxt: string) => void
  updateAnnonceur: (newTxt: string) => void
  updateReference: (newTxt: string) => void
  updateDateParution: (newTxt: Date) => void
  resetPressSupport: () => void
  pointsDiscountApplied: number
  setPointsDiscountApplied: (val: number) => void
  avoirsDiscountApplied: number
  setAvoirsDiscountApplied: (val: number) => void
  onRequestPaymentIntent?: (
    amount: number, 
    description?: string,
    discountDetails?: {
      discountPercentageAmount: number;
      pointsDiscountAmount: number;
      creditNoteDiscountAmount: number;
      totalDiscountAmount: number;
      discountClaimed: boolean;
      discountSentToClient: boolean;
    }
  ) => Promise<void>;
  
  discountDetails?: {
    discountPercentageAmount: number;
    pointsDiscountAmount: number;
    creditNoteDiscountAmount: number;
    totalDiscountAmount: number;
    discountClaimed: boolean;
    discountSentToClient: boolean;
  };
  setDiscountDetails?: (details: any) => void;
}

type PendingPromo = {
  finalDiscountPercentage: number
  originalDiscountPercentage: number
  isCapped: boolean
  promoCodeUsed: string
}

interface BillingClientSelection {
  id: string;
  name: string;
  email: string;
}

const getPrixHT = (support?: PressData | null): number => {
  if (!support) return 0
  if (typeof support.prixMajoreHT === "number") return support.prixMajoreHT
  return Number.parseFloat(support.prixHT || "0")
}

const getPrixTTC = (support?: PressData | null): number => {
  if (!support) return 0
  if (typeof support.prixMajoreTTC === "number") return support.prixMajoreTTC
  return Number.parseFloat(support.prixTTC || "0")
}

const Validation: React.FC<ValidationProps> = ({
  selectedSupport,
  txtAnnonce,
  denomination,
  type_annonce,
  floid,
  entete,
  reference,
  updateDateParution,
  pointsDiscountApplied,
  setPointsDiscountApplied,
  avoirsDiscountApplied,
  setAvoirsDiscountApplied,
  onRequestPaymentIntent,
  discountDetails,
  setDiscountDetails,
}) => {
  const {
    companyName,
    pressSupportPostalCode,
    setPressSupportPostalCode,
    pressSupportCity,
    setPressSupportCity,
    currentAnnoucement,
    setSelectedType,
    setCurrentAnnoucement,
    setActiveIndex,
    setCheckedIndex,
    setUserAnnonces,
    pointsToUse,
    setPointsToUse,
    denomination: contextDenomination,
    texteAnnonce: contextTexteAnnonce,
    legalForm: contextLegalForm,
    discountId
  } = useAppContext() as AppContextType

  // États
  const [startDate, setStartDate] = useState<Date | null>(new Date())
  const [showDatePicker, setShowDatePicker] = useState(false)
  const [imageFile, setImageFile] = useState<File | null>(null)
  const [isChecked, setIsChecked] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [showPromoModal, setShowPromoModal] = useState<boolean>(false)
  const [appliedDiscount, setAppliedDiscount] = useState<number | null>(null)
  const [originalPromoDiscount, setOriginalPromoDiscount] = useState<number | null>(null)
  const [isPromoCapped, setIsPromoCapped] = useState<boolean>(false)
  const [loadingUserAnnonces, setLoadingUserAnnonces] = useState(true)
  const [availableAvoirs, setAvailableAvoirs] = useState<CreditNoteType[]>([])
  const [showAvoirsModal, setShowAvoirsModal] = useState(false)
  const [loadingAvoirs, setLoadingAvoirs] = useState(false)
  const [usedAvoirsIds, setUsedAvoirsIds] = useState<number[]>([])
  const [appliedPromoCode, setAppliedPromoCode] = useState<string | null>(null)
  const [avoirAmountToUse, setAvoirAmountToUse] = useState<number>(0)
  const [showEmailModal, setShowEmailModal] = useState(false)
  const [user, setUser] = useState({
    id: "",
    name: "",
    firstname: "",
    email: "",
    reference: "",
    civility: "",
    code_parrainage: "",
    adresse: "",
    number: "",
    country: "",
    postal_code: "",
    createdAt: "",
    raison_social: "",
    code_SIREN: "",
    code_NAF: "",
    tv_intra: "",
    hasFreeAnnouncement: false,
    user_type: "",
    avoir_balance: 0
  })

  const [showPointsModal, setShowPointsModal] = useState(false)
  const [userDetails, setUserDetails] = useState<UserModel | null>(null)
  const [pendingPromo, setPendingPromo] = useState<PendingPromo | null>(null)

  const { commission, loading: commissionLoading } = useUserLoyaltyCommission(Number(user.id))
  const hasActiveCommission = () => commission && commission.isActive && commission.commissionPercentage > 0 && !commissionLoading

  // Nouveaux états Facturation
  const [wantsBilling, setWantsBilling] = useState<boolean>(false)
  const [showBillingClientModal, setShowBillingClientModal] = useState<boolean>(false)
  const [selectedBillingClient, setSelectedBillingClient] = useState<BillingClientSelection | null>(null)
  const [showBillingEmailModal, setShowBillingEmailModal] = useState(false)
  const [announceTempData, setAnnounceTempData] = useState<any>(null)
  const [paymentLink, setPaymentLink] = useState<string>("")
  const [paymentSession, setPaymentSession] = useState<any>(null)

  const navigate = useNavigate()

  const [discountAmount, setDiscountAmount] = useState<number | null>(null);

  const { calculatePoints } = usePointsCalculator();


  const [discountClaimed, setDiscountClaimed] = useState<boolean>(false)
  const [discountSentToClient, setDiscountSentToClient] = useState<boolean>(false)

  // État pour le solde remise
  const [showSoldeRemiseModal, setShowSoldeRemiseModal] = useState(false)
  const [remiseSoldeRemiseEuros, setRemiseSoldeRemiseEuros] = useState<number>(0)

  // Synchroniser avec le parent (NouvelleAnnonce) via props
  useEffect(() => {
    if (setDiscountDetails && discountClaimed !== undefined) {
      setDiscountDetails((prev: any) => ({
        ...prev,
        discountClaimed
      }))
    }
  }, [discountClaimed, setDiscountDetails])


  // Condition pour afficher la facturation client
  const shouldShowBillingOption = () => {
    return user.user_type === "professionnel"
  }

  useEffect(() => {
    const fetchUserData = async () => {
      const userData = await getUserDetails()
      if (userData) {
        const formattedUser = {
          id: userData.id?.toString() || "",
          name: userData.name || "",
          firstname: userData.firstname || "",
          email: userData.email || "",
          reference: userData.reference || "",
          civility: userData.civility || "",
          code_parrainage: userData.code_parrainage || "",
          adresse: userData.adresse || "",
          number: userData.number || "",
          country: userData.country || "",
          postal_code: userData.postal_code || "",
          createdAt: userData.createdAt ? new Date(userData.createdAt).toLocaleDateString() : "",
          raison_social: userData.raison_social || "",
          code_SIREN: userData.code_SIREN || "",
          code_NAF: userData.code_NAF || "",
          tv_intra: userData.tv_intra || "",
          hasFreeAnnouncement: userData.hasFreeAnnouncement || false,
          user_type: userData.user_type || "",
          avoir_balance: userData.avoir_balance || 0,
          soldeRemise: userData.soldeRemise || 0
        }
        setAvoirAmountToUse(userData.avoir_balance || 0)
        setUser(formattedUser)
        fetchAvailableAvoirs(formattedUser.id)
      }
    }
    fetchUserData()
  }, [])

  useEffect(() => {
    const fetchAnnonces = async () => {
      try {
        const fetchedAnnonces = await getAllAnnonceByUser()
        if (fetchedAnnonces) {
          setUserAnnonces(fetchedAnnonces.filter((annonce: Annonce) => annonce.status !== 3))
        }
        setLoadingUserAnnonces(false)
      } catch (error) {
        console.error("Erreur lors de la récupération des annonces:", error)
      }
    }
    fetchAnnonces()
  }, [])

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const user = await getUserDetails()
        if (user) setUserDetails(user)
      } catch (error) { }
    }
    fetchUserDetails()
  }, [])

  const fetchAvailableAvoirs = async (userId: string) => {
    if (!userId || userId === 'undefined' || userId === 'null' || userId.trim() === '' || userId === '0') {
      console.warn('[VALIDATION] UserId invalide, pas de récupération des avoirs')
      setAvailableAvoirs([])
      setLoadingAvoirs(false)
      return
    }

    try {
      setLoadingAvoirs(true)
      const avoirs = await getUtilisableAvoirs(userId)

      console.log('🔍 Avoirs récupérés pour userId:', userId, '→', avoirs.length, 'avoir(s)')

      if (Array.isArray(avoirs)) {
        setAvailableAvoirs(avoirs)
      } else {
        console.warn('[VALIDATION] Réponse invalide, tableau attendu')
        setAvailableAvoirs([])
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des avoirs:", error)
      setAvailableAvoirs([])
    } finally {
      setLoadingAvoirs(false)
    }
  }

  // Calculs remises CUMULABLES
  const prixHT = getPrixHT(selectedSupport)
  const prixTTC = getPrixTTC(selectedSupport)
  
  // Commission de fidélité
  const commissionVal = hasActiveCommission() ? commission?.commissionPercentage || 0 : 0
  
  // Code promo (accepté même avec d'autres remises)
  const codePromoVal = (appliedDiscount !== null) 
    ? appliedDiscount 
    : (pendingPromo ? pendingPromo.finalDiscountPercentage : 0)

  // Total des remises en pourcentage (cumulables)
  const remisePourcentage = (commissionVal || 0) + (codePromoVal || 0)
  
  // Remises en euros (cumulables avec les pourcentages)
  const remisePointsEuros = pointsDiscountApplied || 0
  const remiseAvoirsEuros = avoirsDiscountApplied || 0
  const remiseSoldeEuros = remiseSoldeRemiseEuros || 0
  
  // Calcul du montant final (toutes remises cumulées)
  const montantApresRemisePourcentage = prixTTC * (1 - remisePourcentage / 100)
  const amountToPay = user.hasFreeAnnouncement
    ? 0
    : discountClaimed || discountSentToClient
      ? prixTTC 
      : Math.max(0, montantApresRemisePourcentage - remisePointsEuros - remiseAvoirsEuros - remiseSoldeEuros)
    
  const isFreeAnnouncement = user.hasFreeAnnouncement || amountToPay === 0

  // Garder les remises TOUJOURS calculées, indépendamment de discountClaimed
  // Les remises ne servent qu'à l'affichage et à la réclamation
  // Seul amountToPay change selon discountClaimed
  const discountPercentageAmount = (prixTTC * remisePourcentage / 100)
  const pointsDiscountAmount = remisePointsEuros
  const creditNoteDiscountAmount = remiseAvoirsEuros
  const soldeRemiseDiscountAmount = remiseSoldeEuros

  const totalDiscountAmount = discountPercentageAmount + pointsDiscountAmount + creditNoteDiscountAmount + soldeRemiseDiscountAmount


  // Initialiser avoirAmountToUse quand la modal s'ouvre
  useEffect(() => {
    if (showAvoirsModal) {
      const montantApresRemisePourcentage = prixTTC * (1 - remisePourcentage / 100)
      const montantRestant = Math.max(0, montantApresRemisePourcentage - remisePointsEuros)
      const totalDisponible = Number(user.avoir_balance)

      setAvoirAmountToUse(Math.min(montantRestant, totalDisponible))
    }
  }, [showAvoirsModal, prixTTC, remisePourcentage, remisePointsEuros, user.avoir_balance])

  // Fonction pour obtenir le montant total des avoirs
  const getTotalAvoirsAmount = () => {
    return availableAvoirs.reduce((total, avoir) => total + Number(avoir.montant_avoir), 0)
  }

  // Fonction pour sélectionner les avoirs à utiliser
  const selectAvoirsForAmount = (targetAmount: number): number[] => {
    const selected: number[] = []
    let currentSum = 0

    const sortedAvoirs = [...availableAvoirs].sort((a, b) =>
      Number(a.montant_avoir) - Number(b.montant_avoir)
    )

    for (const avoir of sortedAvoirs) {
      if (currentSum >= targetAmount) break

      const montantAvoir = Number(avoir.montant_avoir)
      if (currentSum + montantAvoir <= targetAmount) {
        selected.push(avoir.id)
        currentSum += montantAvoir
      }
    }

    if (currentSum < targetAmount && selected.length < availableAvoirs.length) {
      const remaining = availableAvoirs.find(a => !selected.includes(a.id))
      if (remaining) {
        selected.push(remaining.id)
      }
    }

    return selected
  }

  const resetPoints = () => {
  setPointsToUse(0);
};

  // Désactivation / réinitialisation des remises quand facturation demandée
  const handleBillingToggle = () => {
    const next = !wantsBilling

    if (next) {
      setShowBillingClientModal(true)
      setWantsBilling(true)
    } else {
      setShowBillingClientModal(false)
      setSelectedBillingClient(null)
      setWantsBilling(false)
    }
  }


const handleRemoveBillingClient = () => {
    Swal.fire({
      title: "Supprimer le client ?",
      text: "Voulez-vous vraiment annuler la facturation client ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Oui, supprimer",
      cancelButtonText: "Annuler"
    }).then((result) => {
      if (result.isConfirmed) {
        setWantsBilling(false)
        setSelectedBillingClient(null)
        Swal.fire({
          title: "Client supprimé",
          text: "La facturation client a été annulée.",
          icon: "success",
          timer: 1500,
          toast: true,
          position: "top-right"
        })
      }
    })
  }
  const handleBillingClientConfirm = (client: BillingClientSelection) => {
    setSelectedBillingClient(client)
    setShowBillingClientModal(false)
    Swal.fire({
      title: "Client sélectionné",
      text: `Facturation demandée pour : ${client.name}`,
      icon: "success",
      timer: 1500,
      toast: true,
      position: "top-right"
    })
  }

  const handleBillingClientCancel = () => {
    setShowBillingClientModal(false)
    setWantsBilling(false)
    setSelectedBillingClient(null)
    Swal.fire({
      title: "Facturation annulée",
      text: "Aucune facturation client n'a été demandée.",
      icon: "info",
      timer: 1200,
      toast: true,
      position: "top-right"
    })
  }

const handleUsePoints = async () => {
  if (pointsToUse <= 0) {
    return;
  }

  setLoading(true);
  try {
    const result = await applyPointsForDiscount(pointsToUse);
    if (result.success) {
      setPointsDiscountApplied(result.discountAmount);
      setUser((prevUser) => ({
        ...prevUser,
        points_balance: result.newBalance,
      }));
      setDiscountAmount(result.discountAmount);
    }
  } catch (error: any) {
  } finally {
    setLoading(false);
  }
};



  const handleUseAvoirs = async () => {
    if (availableAvoirs.length === 0) {
      Swal.fire("Erreur", "Aucun avoir disponible.", "error")
      return
    }

    if (avoirAmountToUse <= 0) {
      Swal.fire("Erreur", "Veuillez saisir un montant valide.", "error")
      return
    }

    const totalDisponible = getTotalAvoirsAmount()
    if (avoirAmountToUse > totalDisponible) {
      Swal.fire("Erreur", `Le montant saisi dépasse le solde disponible (${totalDisponible.toFixed(2)} €)`, "error")
      return
    }

    const montantApresRemisePourcentage = prixTTC * (1 - remisePourcentage / 100)
    const montantRestant = Math.max(0, montantApresRemisePourcentage - remisePointsEuros)

    if (avoirAmountToUse > montantRestant) {
      const result = await Swal.fire({
        title: "Attention",
        text: `Le montant à utiliser (${avoirAmountToUse.toFixed(2)} €) dépasse le montant restant à payer (${montantRestant.toFixed(2)} €). Voulez-vous ajuster automatiquement ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, ajuster",
        cancelButtonText: "Annuler"
      })

      if (result.isConfirmed) {
        setAvoirAmountToUse(montantRestant)
        setAvoirsDiscountApplied(montantRestant)

        const selectedAvoirs = selectAvoirsForAmount(montantRestant)
        setUsedAvoirsIds(selectedAvoirs)

        Swal.fire("Succès", `${montantRestant.toFixed(2)} € d'avoirs seront utilisés pour cette annonce.`, "success")
        setShowAvoirsModal(false)
      }
      return
    }

    // Ne plus désactiver les autres remises
    setAvoirsDiscountApplied(avoirAmountToUse)

    const selectedAvoirs = selectAvoirsForAmount(avoirAmountToUse)
    setUsedAvoirsIds(selectedAvoirs)

    try {
    const userData = await getUserDetails();
    if (userData) {
      setUser(prev => ({
        ...prev,
        avoir_balance: userData.avoir_balance || 0
      }));
    }
  } catch (error) {
    console.error("Erreur rafraîchissement solde:", error);
  }

    Swal.fire("Succès", `Vous avez utilisé ${avoirAmountToUse.toFixed(2)} € d'avoirs pour cette annonce.`, "success")
    setShowAvoirsModal(false)
  }

  const handlePromoCodeSuccess = (
    finalDiscountPercentage: number,
    originalDiscountPercentage: number,
    isCapped: boolean,
    promoCodeUsed: string
  ) => {
    // On accepte désormais l'application d'un code promo même si wantsBilling est true
    setPendingPromo({
      finalDiscountPercentage,
      originalDiscountPercentage,
      isCapped,
      promoCodeUsed
    })
    setShowPromoModal(false)
  }

  const generatePDF = () => {
    const pdf = new jsPDF()
    const logoWidth = 100
    const logoWidthAttestation = 40
    const logoHeightAttestation = 20
    const logoPositionYAttestation = 15
    const logoPositionXAttestation = (pdf.internal.pageSize.getWidth() - logoWidth / 2) / 2
    const logoWidthAttestation1 = 40
    const logoHeightAttestation1 = 30
    const logoPositionYAttestation1 = 9
    const logoPositionXAttestation1 = (pdf.internal.pageSize.getWidth() - logoWidth / 2) / 2
    const borderRadius = 5
    const backgroundPadding = 20
    const backgroundPadding1 = 30
    const estimateRef = new Date().getMilliseconds()

    pdf.setFillColor(42, 145, 157)
    pdf.roundedRect(
      logoPositionXAttestation - backgroundPadding1 / 3,
      logoPositionYAttestation - backgroundPadding / 2,
      logoWidthAttestation + backgroundPadding,
      logoHeightAttestation + backgroundPadding,
      borderRadius,
      borderRadius,
      "F",
    )
    pdf.addImage(
      logo,
      "PNG",
      logoPositionXAttestation1,
      logoPositionYAttestation1,
      logoWidthAttestation1,
      logoHeightAttestation1,
    )

    pdf.setFontSize(16)
    pdf.setFont("helvetica", "bold")
    pdf.text(`DEVIS N° ${estimateRef}`, 20, 70)
    pdf.setFontSize(12)
    pdf.setFont("helvetica", "normal")

    const clientName = wantsBilling && selectedBillingClient
      ? selectedBillingClient.name
      : `${user.name ?? ""} ${user.firstname ?? ""}`
    const clientRef = wantsBilling && selectedBillingClient
      ? `Qui facture le client: ${user.name ?? ""} ${user.firstname ?? ""}`
      : `Référence client: ${user.reference ?? ""}`

    pdf.text(`Client: ${clientName}`, 20, 80)
    pdf.text(`${clientRef}`, 20, 86)
    pdf.text(`Date : ${format(new Date(), "dd/MM/yyyy")}`, 140, 80)

    // On affiche les remises même si wantsBilling = true (comportement demandé)
    let remisesDescription: string[] = []
    if (commissionVal > 0) remisesDescription.push(`Fidélité: -${commissionVal}%`)
    if (codePromoVal > 0) remisesDescription.push(`Code promo: -${codePromoVal}%`)
    if (remisePointsEuros > 0) remisesDescription.push(`Points: -${remisePointsEuros.toFixed(2)} €`)
    if (remiseAvoirsEuros > 0) remisesDescription.push(`Avoirs: -${remiseAvoirsEuros.toFixed(2)} €`)

    autoTable(pdf, {
      startY: 100,
      head: [["Désignation", "PU TTC", "Remises", "Prix à payer TTC"]],
      body: [
        [
          `Parution du ${selectedSupport?.diffusion || ""} dans ${selectedSupport?.support || ""}`,
          `${prixTTC.toFixed(2)} €`,
          remisesDescription.join(" + ") || "-",
          `${amountToPay.toFixed(2)} €`,
        ],
      ],
      theme: "grid",
      headStyles: {
        fillColor: [42, 145, 157],
      },
    })

    let y = (pdf as any).lastAutoTable?.finalY + 10 || 140
    pdf.setFontSize(11)
    pdf.setFont("helvetica", "normal")

    if (commissionVal > 0) {
      pdf.text(`Remise fidélité appliquée : ${commissionVal}%`, 20, y)
      y += 7
    }
    if (codePromoVal > 0) {
      pdf.text(`Remise code promo appliquée : ${codePromoVal}%`, 20, y)
      y += 7
    }
    if (remisePointsEuros > 0) {
      pdf.text(`Réduction points : -${remisePointsEuros.toFixed(2)} €`, 20, y)
      y += 7
    }
    if (remiseAvoirsEuros > 0) {
      pdf.text(`Réduction avoirs : -${remiseAvoirsEuros.toFixed(2)} €`, 20, y)
      y += 7
    }

    if (isFreeAnnouncement) {
      pdf.setFont("helvetica", "bold")
      pdf.setTextColor(0, 128, 0)
      pdf.text("ANNONCE OFFERTE", 20, y + 10)
      pdf.setTextColor(0, 0, 0)
      pdf.setFont("helvetica", "normal")
    }
    const pageHeight = pdf.internal.pageSize.getHeight()
    pdf.setFontSize(8)
    pdf.setFont("helvetica", "normal")
    pdf.text("Devis valable 30 jours. TVA non applicable - Article 293 B du CGI.", 20, pageHeight - 30)
    pdf.text("Conditions générales de vente disponibles sur notre site web.", 20, pageHeight - 25)
    pdf.save(`DEVIS_N°${estimateRef}.pdf`)
  }

const handlePayerClick = async () => {
  if (loading) return;
  if (wantsBilling && Number(prixTTC) <= 0.5) {
    setShowEmailModal(true);
    return;
  }
  else if (Number(amountToPay) <= 0.5) {
    setShowEmailModal(true);
    return;
  }
  if (!selectedSupport) {
    Swal.fire("Erreur", "Aucun support sélectionné", "error");
    return;
  }
  if (!onRequestPaymentIntent) {
    Swal.fire("Erreur", "Fonction de paiement non disponible", "error");
    return;
  }
  
  setLoading(true);
  
  // Dans handlePayerClick
  const discountDetails = {
    discountPercentageAmount,
    pointsDiscountAmount,
    creditNoteDiscountAmount,
    totalDiscountAmount,
    discountClaimed,
    discountSentToClient
  };

  await onRequestPaymentIntent(amountToPay, "Paiement annonce légale", discountDetails);
  setLoading(false);
};

  const formatDateForRequest = (date: Date | null): string => {
    if (!date) return ""
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    return `${year}${month}${day}`
  }

const handleAnnounceCreationForBilling = async (
  paymentRef: string,
  lienPaiement: string
): Promise<any | null> => {
  if (!selectedSupport) {
    Swal.fire("Erreur", "Aucun support sélectionné", "error");
    return null;
  }

  if (!startDate) {
    Swal.fire("Erreur", "Veuillez sélectionner une date de parution.", "error");
    return null;
  }

  setLoading(true);
  const formattedDate = formatDateForRequest(startDate);

  try {
    // Calcul des points avant la création
    const pointsEarned = calculatePoints(amountToPay);

    const announceData: any = {
      texte: txtAnnonce,
      numdossier: "",
      numannonce: "",
      paymentRef,
      referenceClient: reference,
      annonceur: contextDenomination,
      annonce: txtAnnonce,
      departement: selectedSupport?.departement,
      jal: selectedSupport?.id,
      nJustif: "",
      type_annonce: type_annonce?.sSType,
      demande: formattedDate,
      type: type_annonce?.nType,
      stype: type_annonce?.nSType,
      entete,
      floid,
      textAnnonce: txtAnnonce,
      denomination: contextDenomination || denomination,
      reference_client: companyName.clientReference,
      userId: user.id,
      tv_intra: 0,
      postalCode: pressSupportPostalCode,
      city: pressSupportCity,
      isFree: user.hasFreeAnnouncement,
      montantHTannonce: (Number(amountToPay) * 100) / 120,
      montantTTCannonce: amountToPay,
      montantFinalTTC: amountToPay,
      PromoCodeId: discountId,
      commission_percentage: commissionVal,
      usedPoints: pointsToUse,
      usedAvoirsIds: usedAvoirsIds,
      creditNoteAmount: avoirsDiscountApplied,
      legalMoTTC: getPrixTTC(selectedSupport),
      legaMoHT: getPrixHT(selectedSupport),
      clientId: selectedBillingClient?.id,
      lienPaiement,
      pointsEarned // 🔹 On ajoute les points gagnés à l'objet
    };

    console.log("data annonce :",announceData)
    // Création de l'annonce côté backend
    const response = await createAnnonceForBilling(announceData, imageFile);

    if (!response || response.error) {
      Swal.fire("Erreur", "Erreur lors de la création de l'annonce.", "error");
      return null;
    }

    // 🔹 Mise à jour des points utilisateur
    await updateUserPoints(
      announceData.userId,   // ID utilisateur
      pointsEarned,          // points gagnés
      announceData.usedPoints // points utilisés
    );

    // Mise à jour locale pour l'affichage immédiat
    setAnnounceTempData({ ...response.annonce });

    return response.annonce;
  } catch (error) {
    console.error(error);
    Swal.fire(
      "Erreur",
      "Une erreur est survenue lors de la création de l'annonce temporaire.",
      "error"
    );
    return null;
  } finally {
    setLoading(false);
  }
};


  const handleBillingButtonClick = async () => setShowBillingEmailModal(true)

  const handleAnnounceCreation = async () => {
  setLoading(true)
  const formattedDate = formatDateForRequest(new Date())

  try {
    const finalPromoPercent = pendingPromo ? pendingPromo.finalDiscountPercentage : appliedDiscount || 0

    const totalDiscountPercentage = (commissionVal || 0) + (finalPromoPercent || 0)
    const montantApresPourcentage = prixTTC * (1 - totalDiscountPercentage / 100)
    const finalAmountTTC = user.hasFreeAnnouncement
      ? 0
      : Math.max(0, montantApresPourcentage - (pointsDiscountApplied || 0) - (remiseAvoirsEuros || 0))

    const freePaymentRef = `FREE_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`

    const announceData: any = {
      texte: txtAnnonce,
      numdossier: "",
      numannonce: "",
      paymentRef: freePaymentRef,
      referenceClient: reference,
      annonceur: contextDenomination,
      annonce: txtAnnonce,
      departement: selectedSupport?.departement,
      jal: selectedSupport?.id,
      nJustif: "",
      type_annonce: type_annonce?.sSType,
      demande: formattedDate,
      type: type_annonce?.nType,
      stype: type_annonce?.nSType,
      entete,
      floid,
      textAnnonce: txtAnnonce,
      denomination: contextDenomination || denomination,
      reference_client: companyName.clientReference,
      userId: user.id,
      tv_intra: 0,
      postalCode: pressSupportPostalCode,
      city: pressSupportCity,
      isFree: user.hasFreeAnnouncement,
      montantHTannonce: (Number(finalAmountTTC) * 100) / 120,
      montantTTCannonce: finalAmountTTC,
      montantFinalTTC: finalAmountTTC,
      PromoCodeId: discountId,
      commission_percentage: commissionVal,
      usedPoints: pointsToUse,
      usedAvoirsIds: usedAvoirsIds,
      creditNoteAmount: avoirsDiscountApplied,
      legalMoTTC: getPrixTTC(selectedSupport),
      legaMoHT: getPrixHT(selectedSupport)
    }

    const createdAnnouncement = await createFreeAnnouncement(announceData, imageFile)

    if (pendingPromo && createdAnnouncement?.id) {
      try {
        const promoResult = await promoCodeService.applyPromoCodeForAnnouncement({
          userId: user.id,
          code: pendingPromo.promoCodeUsed,
          announcementId: createdAnnouncement.id.toString()
        })

        if (promoResult.applied) {
          setAppliedDiscount(pendingPromo.finalDiscountPercentage)
          setOriginalPromoDiscount(pendingPromo.originalDiscountPercentage)
          setIsPromoCapped(pendingPromo.isCapped)
          setAppliedPromoCode(pendingPromo.promoCodeUsed)

          if (pendingPromo.finalDiscountPercentage === 100) {
            setUser((prev) => ({ ...prev, hasFreeAnnouncement: true }))
          }

          Swal.fire({
            title: "Code promo appliqué !",
            text: `Votre code promo a été appliqué avec succès (${pendingPromo.finalDiscountPercentage}% de remise)`,
            icon: "success",
            timer: 2000,
            toast: true,
            position: "top-right"
          })
        } else {
          console.error("Échec application code promo:", promoResult.message)
          Swal.fire({
            title: "Attention",
            text: `Code promo non appliqué: ${promoResult.message}. Contactez le support.`,
            icon: "warning",
          })
        }
      } catch (error) {
        console.error("Erreur application code promo:", error)
      }
    }

    const updatedAnnonces = await getAllAnnonceByUser()
    if (updatedAnnonces) {
      setUserAnnonces(updatedAnnonces.filter((annonce: Annonce) => annonce.status !== 3))
    }

    // ✅ AJOUT CRITIQUE : Rafraîchir le solde utilisateur après création
    try {
      const refreshedUser = await getUserDetails()
      if (refreshedUser) {
        setUser(prev => ({
          ...prev,
          avoir_balance: refreshedUser.avoir_balance || 0
        }))
        setAvoirAmountToUse(refreshedUser.avoir_balance || 0)
        console.log('[VALIDATION] ✅ Solde avoir rafraîchi:', refreshedUser.avoir_balance)
      }
    } catch (err) {
      console.error('[VALIDATION] Erreur rafraîchissement solde:', err)
    }

    setPendingPromo(null)
    setAppliedDiscount(null)
    setOriginalPromoDiscount(null)
    setIsPromoCapped(false)
    setAvoirsDiscountApplied(0)
    setAvoirAmountToUse(0)
    setUsedAvoirsIds([])
    setPressSupportPostalCode("")
    setSelectedType(null)
    setPressSupportCity("")
    setCurrentAnnoucement(null)
    setActiveIndex(0)
    setCheckedIndex(0)

    navigate("/home/gestion-annonces")
    Swal.fire({
      title: "Annonce créée avec succès",
      icon: "success",
      showConfirmButton: true,
      confirmButtonText: "Ok",
      confirmButtonColor: "#2A919D",
    })

  } catch (error) {
    Swal.fire({
      title: "Erreur",
      text: "La création d'annonce a échoué!",
      icon: "error",
      showConfirmButton: true,
      confirmButtonText: "Ok",
      confirmButtonColor: "#2A919D",
    })
  } finally {
    setLoading(false)
  }
}

  const confirmValidation = () => {
    Swal.fire({
      title: "VALIDER L'ANNONCE",
      text: "Après la validation de l'annonce vous ne pourrez plus la modifier. Souhaitez-vous valider cette annonce ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#2A919D",
      cancelButtonColor: "#F4A261",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.isConfirmed) {
        handleAnnounceCreation()
      }
    })
  }

  if (loadingUserAnnonces) {
    return (
      <div className="loader-circle" style={{ margin: "auto" }}>
        <div className="inner-circle"></div>
      </div>
    )
  }

  const handleCheckboxChange = () => setIsChecked(!isChecked)
  const handleDatePickerClick = () => setShowDatePicker(!showDatePicker)
  const handleDateChange = (date: Date | null) => {
    if (date) {
      setStartDate(date)
      updateDateParution(date)
      setShowDatePicker(false)
    }
  }

  const handleConfirmBillingEmail = async () => {
  setShowBillingEmailModal(false);

  // Vérifications côté client (nécessaires avant création)
  if (!selectedBillingClient) {
    Swal.fire("Erreur", "Aucun client sélectionné pour la facturation.", "error");
    return;
  }

  if (!selectedSupport) {
    Swal.fire("Erreur", "Aucun support sélectionné.", "error");
    return;
  }

  if (!startDate) {
    Swal.fire("Erreur", "Veuillez sélectionner une date de parution.", "error");
    return;
  }

  if (Number(prixTTC) <= 0) {
    Swal.fire("Erreur", "Le prix du support est invalide.", "error");
    return;
  }

  setLoading(true);

  try {
    const newAnnonce = await handleAnnounceCreationForBilling(Date.now().toString(), process.env.REACT_APP_API_URL || '')

    if (!newAnnonce) {
      Swal.fire("Erreur", "Impossible de créer l'annonce pour facturation.", "error")
      return
    }

    const annonceAmount = Number(newAnnonce.montantTTCannonce ?? amountToPay)

    const stripePaymentSessionPayload = {
      amount: Math.round(amountToPay * 100),
      currency: "eur",
      returnUrl: `${process.env.REACT_APP_BASE_URL}/client/annoucement-creation`,
      description: type_annonce?.sSType,
      userId: localStorage.getItem("userId"),
      clientId: selectedBillingClient?.id,
      annonceId: newAnnonce.id,
    }


    const paymentSession = await createCheckoutSession(stripePaymentSessionPayload);

    if (!paymentSession || !paymentSession.url) {
      throw new Error("Impossible de créer la session de paiement Stripe.");
    }

    const paymentRef = `BILL_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    // const newAnnonce = await handleAnnounceCreationForBilling(paymentRef, paymentSession.url);

    if (!newAnnonce || !newAnnonce.id) {
      throw new Error("Impossible de créer l'annonce temporaire pour la facturation client.");
    }

    // 3) Créer la transaction côté backend (liaison au paymentSession.id)
    await createTransaction({
      amount: Math.round(amountToPay * 100),
      currency: "eur",
      paymentMethod: "card",
      description: type_annonce?.sSType,
      paymentRef: paymentSession.id,
    });

    // 4) Envoyer le mail au client avec le lien
    const announcementDetails = {
      support: selectedSupport?.support,
      amount: annonceAmount,
      type: type_annonce?.sSType || "",
      pdfFactureAlo: `Facture_ALO_Annonce_${new Date().getTime()}.pdf`,
    };

    const paymentLink = paymentSession.url || `${process.env.REACT_APP_API_URL}/stripe/payment-session/generatelink/${newAnnonce?.id}`;

    const defaultMessage = `
    <p>Bonjour,</p>

    <p>Votre conseil ${selectedBillingClient?.name} nous a transmis la demande de publication de votre annonce légale, réalisée en votre faveur.</p>

    <p>Veuillez trouver ci-dessous les éléments relatifs à cette parution :</p>

    <ul>
      <li><strong>Support de presse :</strong> ${announcementDetails.support || '------'}</li>
      <li><strong>Type d’annonce :</strong> ${announcementDetails.type || '--------'}</li>
      <li><strong>Montant à régler :</strong> ${announcementDetails.amount.toFixed(2)} €</li>
      <li><strong>Lien de paiement :</strong> <a href="${process.env.REACT_APP_API_URL}/stripe/payment-session/generatelink/${newAnnonce.id}">Cliquez ici</a></li>
    </ul>

    <p>Le règlement de cette somme permettra la validation immédiate de la publication et l’émission de l’attestation officielle de parution, destinée à votre conseil pour finalisation du dossier.</p>

    <p>Nous vous remercions par avance pour votre réactivité et pour la confiance accordée à notre service.</p>

    <p>Très cordialement,<br/>
    L’équipe ALO<br/>
    Annonce Légale Officielle – <a href="http://ALO-FR.fr">ALO-Annonce Légale Officielle vos annonces en quelques clics</a><br/>
    (Support agréé pour la diffusion d’annonces légales et judiciaires)</p>
    `;

    const payload = {
      name: selectedBillingClient?.name,
      email: selectedBillingClient?.email,
      object: `Facturation de la création d'annonce - ${announcementDetails.type}`,
      sender: undefined,
      message: defaultMessage,
      bcc: [],
      allowUnsubscribe: false,
    }

    await createTransaction({
      amount: Math.round(annonceAmount * 100), // en centimes, utiliser le montant de l'annonce créé
      currency: 'eur',
      paymentMethod: 'card',
      description: type_annonce?.sSType,
      paymentRef: paymentSession.id,
    })

    await sendMail(payload);

    Swal.fire({
      title: "Facturation envoyée",
      text: "La facturation a été envoyée avec succès à votre client.",
      icon: "success",
      timer: 2000,
      toast: true,
      position: "top-right",
    }).then(async () => {
      setActiveIndex(0);
      setCheckedIndex(0);
      setCurrentAnnoucement(null);
      setSelectedType(null);
      navigate("/home/gestion-annonces");
    });
  } catch (err: any) {
    console.error("Erreur facturation client:", err);
    Swal.fire({
      title: "Erreur",
      text: err.message || "Erreur lors de l'envoi de la facturation.",
      icon: "error",
    });
  } finally {
    setLoading(false);
  }
};

const hasRemises =
  remisePourcentage > 0 ||
  remisePointsEuros > 0 ||
  remiseAvoirsEuros > 0 ||
  remiseSoldeEuros > 0;


  return (
    <div className="validation-container">
      <h2 className="validation-title">VALIDATION DE VOTRE ANNONCE</h2>
      <div className="validation-content" style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
        <div className="dossier-info" style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <textarea
            className="textarea"
            value={txtAnnonce}
            placeholder="Entrez vos informations ici..."
            readOnly
            style={{ width: '100%', flex: 1, minHeight: '600px' }}
          ></textarea>

          {/* Lorsque des remises existent, afficher le footer sous le textarea */}
          {hasRemises && (
            <div style={{ marginTop: 12 }}>
              <ValidationFooter
                isChecked={isChecked}
                handleCheckboxChange={handleCheckboxChange}
                shouldShowBillingOption={shouldShowBillingOption}
                wantsBilling={wantsBilling}
                handleBillingToggle={handleBillingToggle}
                amountToPay={amountToPay}
                isFreeAnnouncement={isFreeAnnouncement}
                loading={loading}
                handlePayerClick={handlePayerClick}
                selectedBillingClient={selectedBillingClient}
                handleBillingButtonClick={handleBillingButtonClick}
                confirmValidation={confirmValidation}
                showPointsModal={showPointsModal}
                setShowPointsModal={setShowPointsModal}
                pointsToUse={pointsToUse}
                setPointsToUse={setPointsToUse}
                userDetails={userDetails}
                discountAmount={discountAmount}
                resetPoints={resetPoints}
                handleUsePoints={handleUsePoints}
                showAvoirsModal={showAvoirsModal}
                setShowAvoirsModal={setShowAvoirsModal}
                user={user}
                avoirAmountToUse={avoirAmountToUse}
                setAvoirAmountToUse={setAvoirAmountToUse}
                handleUseAvoirs={handleUseAvoirs}
                prixHT={prixHT}
                prixTTC={prixTTC}
                remisePourcentage={remisePourcentage}
                remisePointsEuros={remisePointsEuros}
                remiseAvoirsEuros={remiseAvoirsEuros}
                discountPercentageAmount={discountPercentageAmount}
                pointsDiscountAmount={pointsDiscountAmount}
                creditNoteDiscountAmount={creditNoteDiscountAmount}
                totalDiscountAmount={totalDiscountAmount}
                selectedSupport={selectedSupport}
                discountClaimed={discountClaimed}
                discountSentToClient={discountSentToClient}
              />
            </div>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
        <ValidationHeader
          selectedSupport={selectedSupport}
          txtAnnonce={txtAnnonce}
          startDate={startDate}
          showDatePicker={showDatePicker}
          setShowDatePicker={setShowDatePicker}
          handleDateChange={handleDateChange}
          generatePDF={generatePDF}
          loading={loading}
          user={user}
          remisePourcentage={remisePourcentage}
          commissionVal={commissionVal}
          codePromoVal={codePromoVal}
          remisePointsEuros={remisePointsEuros}
          remiseAvoirsEuros={remiseAvoirsEuros}
          remiseSoldeEuros={remiseSoldeEuros}
          prixHT={prixHT}
          prixTTC={prixTTC}
          amountToPay={amountToPay}
          isFreeAnnouncement={isFreeAnnouncement}
          appliedDiscount={appliedDiscount}
          pendingPromo={pendingPromo}
          availableAvoirs={availableAvoirs}
          setShowPromoModal={setShowPromoModal}
          setShowPointsModal={setShowPointsModal}
          setShowAvoirsModal={setShowAvoirsModal}
          setShowSoldeRemiseModal={setShowSoldeRemiseModal}
          setRemiseSoldeEuros={setRemiseSoldeRemiseEuros}
          selectedBillingClient={selectedBillingClient}
          setShowBillingClientModal={setShowBillingClientModal}
          handleRemoveBillingClient={handleRemoveBillingClient}
          wantsBilling={wantsBilling}
          setUser={setUser}
          
          discountPercentageAmount={discountPercentageAmount}
          pointsDiscountAmount={pointsDiscountAmount}
          creditNoteDiscountAmount={creditNoteDiscountAmount}
          soldeRemiseDiscountAmount={soldeRemiseDiscountAmount}
          totalDiscountAmount={totalDiscountAmount}
          discountClaimed={discountClaimed}
          setDiscountClaimed={setDiscountClaimed}
          discountSentToClient={discountSentToClient}
          setDiscountSentToClient={setDiscountSentToClient}
          showSoldeRemiseModal={showSoldeRemiseModal}
          
          setRemisePointsEuros={setPointsDiscountApplied}
          setRemiseAvoirsEuros={setAvoirsDiscountApplied}
          resetPromoCode={() => {
            setAppliedDiscount(null);
            setPendingPromo(null);
          }}
        />

           {!hasRemises && (
            <ValidationFooter
            isChecked={isChecked}
            handleCheckboxChange={handleCheckboxChange}
            shouldShowBillingOption={shouldShowBillingOption}
            wantsBilling={wantsBilling}
            handleBillingToggle={handleBillingToggle}
            amountToPay={amountToPay}
            isFreeAnnouncement={isFreeAnnouncement}
            loading={loading}
            handlePayerClick={handlePayerClick}
            selectedBillingClient={selectedBillingClient}
            handleBillingButtonClick={handleBillingButtonClick}
            confirmValidation={confirmValidation}
            showPointsModal={showPointsModal}
            setShowPointsModal={setShowPointsModal}
            pointsToUse={pointsToUse}
            setPointsToUse={setPointsToUse}
            userDetails={userDetails}
            discountAmount={discountAmount}
            resetPoints={resetPoints}
            handleUsePoints={handleUsePoints}
            showAvoirsModal={showAvoirsModal}
            setShowAvoirsModal={setShowAvoirsModal}
            user={user}
            avoirAmountToUse={avoirAmountToUse}
            setAvoirAmountToUse={setAvoirAmountToUse}
            handleUseAvoirs={handleUseAvoirs}
            prixHT={prixHT}
            prixTTC={prixTTC}
            remisePourcentage={remisePourcentage}
            remisePointsEuros={remisePointsEuros}
            remiseAvoirsEuros={remiseAvoirsEuros}
            
            discountPercentageAmount={discountPercentageAmount}
            pointsDiscountAmount={pointsDiscountAmount}
            creditNoteDiscountAmount={creditNoteDiscountAmount}
            totalDiscountAmount={totalDiscountAmount}
            
            selectedSupport={selectedSupport}

            discountClaimed={discountClaimed}
            discountSentToClient={discountSentToClient}
          />)}

        </div>
      </div>

      {/* Modals */}
      <BillingClientModal
        show={showBillingClientModal}
        onHide={handleBillingClientCancel}
        onClientConfirm={handleBillingClientConfirm}
      />

      <BillingEmailModal
        visible={showBillingEmailModal}
        onCancel={() => setShowBillingEmailModal(false)}
        onSuccess={handleConfirmBillingEmail}
        clientEmail={selectedBillingClient?.email || ""}
        clientName={selectedBillingClient?.name || ""}
        announcementDetails={{
          support: selectedSupport?.support,
          amount: getPrixTTC(selectedSupport),
          type: type_annonce?.sSType || "",
          montantTTC: amountToPay,
        }}
        paymentLink={paymentLink}
      />

      <PromoCodeModal
        show={showPromoModal}
        onHide={() => setShowPromoModal(false)}
        onSuccess={(finalDiscountPercentage: number, originalDiscountPercentage: number, isCapped: boolean, promoCodeUsed: string) => {
          handlePromoCodeSuccess(finalDiscountPercentage, originalDiscountPercentage, isCapped, promoCodeUsed)
        }}
        userId={user.id}
      />

      {showEmailModal && (
        <EmailModal
          show={showEmailModal}
          onClose={() => setShowEmailModal(false)}
          recipientName="Service Support ALO"
          recipientEmail="site.terrier+admin@gmail.com"
          currentUserEmail={localStorage.getItem("userEmail") || ""}
          subject="Montant trop faible pour paiement"
          message={`Bonjour, le montant de l'annonce sélectionnée est inférieur à 0.5 €. Veuillez vérifier.`}
          fromUserListPoint={false}
          minAnnonceAmount={true}
        />
      )}
    </div>
  )
}

export default Validation